// "Subcontractors": the box beside Temps active on the Crew Schedule (#688).
// The box is TypedHeadcountBox, shared with Temps active (#584); what the
// figure is, including that it is counted INSIDE Available MP like temps, is
// SUBCONTRACTORS_ACTIVE in typedHeadcounts.ts.

import TypedHeadcountBox from './TypedHeadcountBox';
import { SUBCONTRACTORS_ACTIVE } from './typedHeadcounts';

export default function SubcontractorsActiveBox(props: { availableMp: number | null; canEdit: boolean }) {
  return <TypedHeadcountBox figure={SUBCONTRACTORS_ACTIVE} {...props} />;
}
